import httpClient from './httpClient'

export default {
  DeviceTrigger: {
    GetDeviceTriggerTypes(payload) {
      return httpClient.post('/DeviceTrigger/GetDeviceTriggerTypes', payload)
    },
    GetDeviceLightOptions(payload) {
      return httpClient.post('/DeviceTrigger/GetDeviceLightOptions', payload)
    },
    GetDeviceLightColors(payload) {
      return httpClient.post('/DeviceTrigger/GetDeviceLightColors', payload)
    },
    GetDeviceTriggers(payload) {
      return httpClient.post('/DeviceTrigger/GetDeviceTriggers', payload)
    },
    GetAvailableDeviceVcaRules(payload) {
      return httpClient.post(
        '/DeviceTrigger/GetAvailableDeviceVcaRules',
        payload
      )
    },
    CreateDeviceTrigger(payload) {
      return httpClient.post('/DeviceTrigger/CreateDeviceTrigger', payload)
    },
    UpdateDeviceTrigger(payload) {
      return httpClient.post('/DeviceTrigger/UpdateDeviceTrigger', payload)
    },
    RetryDeviceTrigger(payload) {
      return httpClient.post('/DeviceTrigger/RetryDeviceTrigger', payload)
    },
    DeactivateDeviceTrigger(payload) {
      return httpClient.post('/DeviceTrigger/DeactivateDeviceTrigger', payload)
    },
    ActivateDeviceTrigger(payload) {
      return httpClient.post('/DeviceTrigger/ActivateDeviceTrigger', payload)
    },
    DeleteDeviceTrigger(payload) {
      return httpClient.post('/DeviceTrigger/DeleteDeviceTrigger', payload)
    },
    GetCustomerDeviceTriggerReport(payload) {
      return httpClient.get(
        `/DeviceTrigger/GetCustomerDeviceTriggerReport/${payload.customerId}`,
        payload.config
      )
    },
    DeleteDeviceTriggerRulesByDevice(payload) {
      return httpClient.post(
        '/DeviceTrigger/DeleteDeviceTriggerRulesByDevice',
        payload
      )
    },
  },
}
